
/**
 * ChallengeType 0 is for free for all,
 * ChallengeType 1 is for battle boat,
 * ChallengeType 2 is for shadow boxing
 */
export type ChallengeTypeValues = 0 | 1 | 2;

type TChallengeTypes = {
  [key: string]: ChallengeTypeValues;
};

export const ChallengeTypes: TChallengeTypes = {
  FreeForAll: 0, // 0 or NULL
  BattleBoat: 1,
  ShadowBoxing: 2,
  // More challenges in the future
} as const;

type ChallengeRewarTextParams = {
  challengeType: ChallengeTypeValues, 
  getLocalizedMessage: (key: string, fallback: string) => string,
  quantity: number;
}

export const getChallengeRewardText = ({ challengeType, getLocalizedMessage, quantity }: ChallengeRewarTextParams) => {
  const challengeTypeReward = {
      [ChallengeTypes.ShadowBoxing]: () => {
          return quantity == 1 ? getLocalizedMessage("Gem", "Gem") : getLocalizedMessage("Gems", "Gems");
      },
      default: () => {
          return quantity == 1 ? getLocalizedMessage("Coin", "Coin") : getLocalizedMessage("Coins", "Coins");
      }
  }
  return challengeTypeReward[challengeType] && challengeTypeReward[challengeType]() || challengeTypeReward.default();
}


export const isChallengeAllowedOnWallboard = ({ ChallengeType }: { ChallengeType: number }) => {
  //We only want FreeForAll challenges for now.
  const challengesNotImplemented: number[] = [
    ChallengeTypes.BattleBoat,
    ChallengeTypes.ShadowBoxing,
  ];
  return !challengesNotImplemented.includes(ChallengeType);
};

